import React from 'react';
import PropTypes from 'prop-types';
import { IconSvg } from '@prism/icon';

var IconSizes = {
  xs: '15px',
  sm: '19px',
  md: '25px',
  lg: '33px',
  xl: '47px',
  xxl: '47px'
};

var Spinner = function Spinner(_ref) {
  var color = _ref.color,
      size = _ref.size;
  var iconSize;

  if (IconSizes[size]) {
    iconSize = IconSizes[size];
  } else {
    var parsedSize = parseInt(size, 10);

    if (!Number.isNaN(parsedSize)) {
      var oddSize = parsedSize % 2 === 0 ? parsedSize - 1 : parsedSize;
      iconSize = "".concat(oddSize, "px");
    } else {
      iconSize = IconSizes.md;
    }
  }

  return /*#__PURE__*/React.createElement("span", {
    className: "spinner-wrapper",
    role: "presentation"
  }, /*#__PURE__*/React.createElement(IconSvg, {
    className: "spinner",
    glyph: "spinner",
    color: color,
    height: iconSize
  }));
};

Spinner.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Spinner.defaultProps = {
  color: '#000000',
  size: 'md'
};

export { IconSizes, Spinner as default };
//# sourceMappingURL=index.js.map
